import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  MinusCircleFilled,
} from "@ant-design/icons";
import React from "react";
import CircleSvg from "./CircleSvg";
import images from "../../assets/images";

const GoalIcon = ({ id, goalsStatusData = [], sectionStatus }) => {
  const goal =
    goalsStatusData && goalsStatusData.find((goal) => goal.id === id);
  const goalStatus = goal?.status || "";

  const statusIcons = {
    "Partially Achieved": (
      <MinusCircleFilled className="goal-icon partially-achieved" />
    ),
    Achieved: <CheckCircleFilled className="goal-icon achieved" />,
    "Not Achieved": (
      <ExclamationCircleFilled className="goal-icon not-achieved" />
    ),
    complete: <CheckCircleFilled className="goal-icon answered" />,
    incomplete: (
      <img
        src={images.Dotted_Check}
        alt="Partially Answered"
        className="goal-icon partially-answered"
      />
    ),
  };

  return (
    statusIcons[sectionStatus] ||
    statusIcons[goalStatus] || (
      <div className="goals-icon-circle-container">
        <CircleSvg />
      </div>
    )
  );
};

export default GoalIcon;
